import React from 'react';
interface TitleCoverProps {
  className?: string;
}
export const TitleCover = (props: TitleCoverProps) => {
  return (
    <svg
      className={props.className}
      width="94"
      height="39"
      viewBox="0 0 94 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M77.9871 29.9667C59.5983 37.8484 38.343 38.1519 19.2726 32.3063C13.7099 30.6012 -1.68587 25.5557 1.40627 15.6403C7.20406 -2.95122 41.1327 1.26765 51.9784 1.73202C57.6673 1.97559 63.4447 2.13244 68.9683 3.59733C75.8326 5.4178 84.6306 5.47631 88.8419 11.5085C92.9909 17.4515 95.1329 28.7078 89.9587 33.6636C82.9557 40.3709 71.3027 37.2799 61.8684 37.3436C56.1434 37.3822 35.4683 34.3521 26.2894 31.8076C19.5029 29.9264 4.71454 25.5197 15.546 15.7153C18.0565 13.4428 21.134 11.9514 24.1266 10.4756C31.0952 7.03886 31.9418 7.09503 37.6903 5.92007"
        stroke="#727476"
      />
    </svg>
  );
};
